/**
 * Inventory list navigation contract shared by the sidebar and the inventory page.
 *
 * Inventory keeps its search in component state only (never URL or storage), so
 * the sidebar cannot clear it by changing the URL when the list is already
 * mounted. It sets this flag in `location.state` instead; the list drops its
 * search, returns to page 1, and consumes the flag so a refresh is inert.
 */
export const INVENTORY_LIST_RESET_STATE_KEY = 'inventoryListReset' as const;

export const inventoryListResetState = (): Record<typeof INVENTORY_LIST_RESET_STATE_KEY, true> => ({
    [INVENTORY_LIST_RESET_STATE_KEY]: true,
});
